import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  ModalFullScreen, IconsPack, Typography, styleHelpers,
} from '@pik/pik-ui';
import LazyLoad from 'react-lazyload';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import VideoModal from '../VideoModal';

import S from './styles';

dayjs.extend(relativeTime);

const getDate = (date) => dayjs(date, 'DDMMYYYY').from(dayjs());

const Video = ({ video, isVideoPage, isEng }) => {
  const [show, handleShow] = useState(false);
  const {
    youtubeId, title, titleEng, date, picture,
  } = video;

  let videoTitle = title;

  if (isEng && titleEng) {
    videoTitle = titleEng;
  }

  const formatVideoData = (data) => ({
    ...data,
    video: {
      desktop: null,
      mobile: null,
      youtube: `https://youtu.be/${youtubeId}`,
    },
  });

  return (
    <>
      <S.VideoWrapper>
        <S.Video
          key={videoTitle}
          onClick={() => handleShow(true)}
          className={isVideoPage ? 'video-page' : ''}
        >
          <LazyLoad offset={[400, 200]}>
            <S.VideoImage src={isVideoPage ? `//img.youtube.com/vi/${youtubeId}/hqdefault.jpg` : picture} />
          </LazyLoad>
          {!isVideoPage && <S.VideoTitle dangerouslySetInnerHTML={{ __html: videoTitle }} />}
          <S.VideoHover />
          <S.VideoPlay>
            <IconsPack name="play" size="xl" />
          </S.VideoPlay>
        </S.Video>
        <S.BottomTitle className={isVideoPage ? 'video-page' : ''}><Typography type="h5" weight="medium">{videoTitle}</Typography></S.BottomTitle>
        <S.Date className={isVideoPage ? 'video-page' : ''}><Typography type="body" color={styleHelpers.colors.secondaryMedium}>{ getDate(date) }</Typography></S.Date>
      </S.VideoWrapper>
      <ModalFullScreen root="modal" active={show} onClose={() => handleShow(false)}>
        <VideoModal video={isVideoPage ? formatVideoData(video) : video} />
      </ModalFullScreen>
    </>
  );
};

Video.propTypes = {
  video: PropTypes.shape({
    id: PropTypes.number,
    picture: PropTypes.string,
    title: PropTypes.string,
    date: PropTypes.string,
    isVideoPage: PropTypes.bool,
    youtubeId: PropTypes.string,
  }).isRequired,
};

export default Video;
